import React from "react";
import MatchReasonsPopover from "@/components/MatchReasonsPopover";
import { formatMatchScore } from "./formatMatchScore";

// The introduction picker's badge. With an AI pairing it reads exactly like the
// feed card: AI score, spark, and the "why this home" popover.
//
// Without one: nothing at all where the environment serves AI rankings, since a
// green "100% Match" beside an AI score is a second, louder answer to the same
// question. Where it doesn't (aiDisplay false), the matcher score stays — that
// is the only match signal those tenants have.
const IntroMatchBadge = ({ property, ai = null, aiDisplay = false }) => {
  const aiScore = Math.round(Number(ai?.aiScore));
  const hasAiScore = Number.isFinite(aiScore) && aiScore > 0;
  if (aiDisplay && !hasAiScore) return null;

  const score = hasAiScore ? aiScore : formatMatchScore(property?.score);
  const hasAiReason = typeof ai?.reason === "string" && !!ai.reason;

  const badge = (
    <div
      className={`match-tag intro-match-tag${
        hasAiReason ? " mls-match-tag--ai" : ""
      }`}
    >
      {hasAiReason && (
        // <i>, not <span>: the picker row styles every descendant span as the
        // row card itself (see PropertySelection.scss).
        <i className="mls-match-tag__spark" aria-hidden="true">
          ✦
        </i>
      )}
      {score}% Match
    </div>
  );

  if (!hasAiReason) return badge;

  return (
    <MatchReasonsPopover
      reasons={property?.reasons}
      score={score}
      perspective="seller"
      ai={ai}
    >
      {badge}
    </MatchReasonsPopover>
  );
};

export default IntroMatchBadge;
